import React from 'react';
import MixerControl from './MixerControl/MixerControl';
import { BODY_PARTS, MixerControlsContext } from '../../containers/PixelMixer/PixelMixer';
import classes from './MixerControls.module.css';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { trackMixerEvent } from '../../analytics/mixers';

export const MixerControls = (props) => {
  return (
    <div className={classes.MixerControlContainer}>
      <Button onClick={() => {
        props.onRandomize();
        trackMixerEvent('mixer_randomized', { scope: 'all' });
      }} variant="outlined">
        Randomize All
      </Button>
      <MixerControlsContext.Consumer>
        {(context) => {
          return (
            <React.Fragment>
              <MixerControl
                champData={props.champData}
                ref={context.headRef}
                changeHandler={props.onHeadChange}
                val={context.head}
                bodyPart={BODY_PARTS.HEAD}
                key={BODY_PARTS.HEAD}
              />

              {context.isAshe && (
                <MixerControl
                champData={props.champData}
                  ref={context.head2Ref}
                  changeHandler={props.onHead2Change}
                  val={context.head2}
                  bodyPart={BODY_PARTS.HEAD2}
                  key={BODY_PARTS.HEAD2}
                />
              )}
              <MixerControl
                champData={props.champData}
                ref={context.torsoRef}
                changeHandler={props.onTorsoChange}
                val={context.torso}
                bodyPart={BODY_PARTS.TORSO}
                key={BODY_PARTS.TORSO}
              />
              {props.isPixelMixer && (
                <MixerControl
                champData={props.champData}
                  ref={context.legsRef}
                  changeHandler={props.onLegsChange}
                  val={context.legs}
                  bodyPart={BODY_PARTS.LEGS}
                  key={BODY_PARTS.LEGS}
                />
              )}
              {/* <label className={didVote(isVoting) ? classes.upvoted : ''}>{`Upvotes: ${voteCount}`}</label> */}
              {/* <Button disabled={didVote(isVoting)} onClick={onUpvote} variant="outlined"> */}
              {/* Upvote this Mix */}
              {/* </Button> */}
              <label htmlFor={'shareLink'}>Share Link</label>
              <TextField
                id={'shareLink'}
                // label="Share Link"
                variant="outlined"
                onClick={props.onCopyToClipboard}
                inputRef={context.shareUrlInputRef}
                value={window.location.href}
                inputProps={{ readOnly: true }}
              />
              {/* <input id={'shareLink'} ref={context.shareUrlInputRef} value={window.location.href} readOnly /> */}
              <Button onClick={props.onCopyToClipboard} variant="outlined" className={classes.copyButton}>
                Copy URL
              </Button>
            </React.Fragment>
          );
        }}
      </MixerControlsContext.Consumer>
    </div>
  );
};
